import React from 'react'
import GoogleAuth from './GoogleAuth'
import TwitterAuth from './TwitterAuth'

const SocialLogin = () => {
  return (
        <div className="md:flex md:space-x-4 space-y-4 md:space-y-0">
          <GoogleAuth />
          <TwitterAuth />
          </div> 
  )
}

export default SocialLogin